function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { Typography } from 'seagull';
import PricingTextField from "../../../../components/ServiceCreation/ServiceBuilder/PricingTextField";
import { defaultInitialState } from "../../../../components/ServiceCreation/ServiceBuilder/ServiceBuilder";
import { serviceToInput } from "../../../../components/ServiceCreation/ServiceBuilder/ServiceBuilder.utils";
import { serviceBillingModel, serviceCostModel, serviceModel } from "../../../../models";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { billingFormToService } from "./service.utils";
import { autoBillingPeriodLabel } from "../../../../utils/service-billing/automatic-service-billing-period";
import UnitNameTextField from "../../../../components/ServiceCreation/ServiceBuilder/UnitNameTextField";
import PreapprovedTextField from "../../../../components/ServiceCreation/ServiceBuilder/PreapprovedTextField";
import BillingTriggerDropdown from "../../../../components/ServiceCreation/ServiceBuilder/BillingTriggerDropdown";
import OccurrenceTextField from "../../../../components/ServiceCreation/ServiceBuilder/OccurrenceTextField";
import { renderBillingSettingsSection } from "../../../../components/ServiceDetails/BillingSettingsSection/BillingSettingsSection";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import styles from "./ServiceBillingCell.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ServiceBillingContent = _ref => {
  let {
    draft,
    service,
    setDraft
  } = _ref;
  const {
    watch,
    getValues,
    setError,
    clearErrors
  } = useFormContext();
  const [pricing] = watch(['pricing']);
  if (!service) return null;
  watch(value => {
    const serviceNewData = _objectSpread(_objectSpread({}, getValues()), value);
    try {
      setDraft(draft.setService(service.id, s => billingFormToService({
        service: s,
        billingForm: serviceNewData
      })));
    } catch (err) {}
  });
  const onDayOfMonthChange = (serviceId, dayOfMonth) => {
    setDraft(draft.setService(service.id, s => serviceModel.setBillingDayOfMonth(s, dayOfMonth)));
  };
  const onDayOfWeekChange = (serviceId, dayOfWeek) => {
    setDraft(draft.setService(service.id, s => serviceModel.setBillingDayOfWeek(s, dayOfWeek)));
  };
  const onBillUpfrontModeChange = (serviceId, billUpfront) => {
    setDraft(draft.setService(service.id, s => serviceModel.setBillUpfront(s, billUpfront)));
  };
  const onDayOfYearChange = (serviceId, dayOfYear) => {
    setDraft(draft.setService(service.id, s => serviceModel.setBillingDayOfYear(s, dayOfYear)));
  };
  const onHasError = (serviceId, hasError) => {
    if (hasError) {
      setError('billingDayOfMonth', {
        message: ''
      });
    } else {
      clearErrors('billingDayOfMonth');
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.serviceBillingCell,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.row,
      children: [/*#__PURE__*/_jsx(PricingTextField, {}), /*#__PURE__*/_jsx(OccurrenceTextField, {
        serviceOrigin: "draft",
        service: service
      })]
    }), ['hour', 'unit'].includes(pricing) && /*#__PURE__*/_jsxs("div", {
      className: styles.row,
      children: [pricing === 'unit' && /*#__PURE__*/_jsx(UnitNameTextField, {}), /*#__PURE__*/_jsx(PreapprovedTextField, {})]
    }), /*#__PURE__*/_jsx(BillingTriggerDropdown, {
      service: service,
      serviceOrigin: "draft",
      effectiveDate: draft.effectiveDate(),
      stagesClassName: styles.stages
    }), renderBillingSettingsSection({
      service,
      testid: "edit-service-billing-modal",
      isActiveAgreement: false,
      onDayOfMonthChange,
      onDayOfWeekChange,
      onDayOfYearChange,
      onBillUpfrontModeChange,
      onHasError
    })]
  });
};
export default function ServiceBillingCell(_ref2) {
  let {
    index,
    service,
    isDisabled,
    disabledTooltip,
    onOpenModal
  } = _ref2;
  const {
    IN_STAGES_OCCURENCE = false
  } = useFeatureFlags();
  const defaultValues = useMemo(() => service ? serviceToInput({
    service,
    qboItems: [],
    xeroItems: [],
    IN_STAGES_OCCURENCE
  }) : defaultInitialState, [service, IN_STAGES_OCCURENCE]);
  const form = useForm({
    mode: 'all',
    defaultValues
  });
  const onClick = () => {
    form.reset(defaultValues);
    onOpenModal({
      width: '640',
      renderContent: _ref3 => {
        let {
          draft,
          setDraft
        } = _ref3;
        return {
          title: 'Service billing',
          testid: "edit-service-billing-modal-".concat(index),
          onSubmit: defaultBehavior => {
            form.handleSubmit(defaultBehavior)();
          },
          content: /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
            children: /*#__PURE__*/_jsx(ServiceBillingContent, {
              service: draft.service(service.id),
              draft: draft,
              setDraft: setDraft
            })
          }))
        };
      }
    });
  };
  const subtitle = useMemo(() => {
    if (serviceBillingModel.isAutomatic(service.billing)) {
      const label = autoBillingPeriodLabel(service.billing);
      return label ? label.text : undefined;
    }
    return serviceCostModel.stringifyServiceCost(service.cost).unitCapDisplay;
  }, [service.billing, service.cost]);
  return /*#__PURE__*/_jsxs(EditableTableCell, {
    testid: "edit-service-billing-cell-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: [/*#__PURE__*/_jsxs(Typography, {
      "data-testid": "service-billing-".concat(index),
      children: [serviceModel.formatRecurrencePeriod(service, IN_STAGES_OCCURENCE), ' • ', serviceModel.formatBillingTrigger(service, IN_STAGES_OCCURENCE)]
    }), /*#__PURE__*/_jsx(Typography, {
      "data-testid": "service-billing-subtitle-".concat(index),
      variant: "paragraph2",
      skin: "secondary",
      children: subtitle
    })]
  });
}